/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-rounded': {
    width: 4.9,
    height: 5.4,
    viewBox: '0 0 4.9 5.4',
    data: '<path pid="0" d="M0 4.4c0 .7.8 1.2 1.4.8l3-1.7c.6-.4.6-1.3 0-1.7L1.4.1C.8-.2 0 .2 0 1v3.4z" _fill="#fff"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/arrow-rounded.js